import { identity, pickBy } from 'lodash';
import moment from 'moment';
export const removeBlank = (obj) => {
  return pickBy(obj,identity);
}


export const removeNullish = (obj) => {
  return pickBy(obj, (v) => v !== null && v !== undefined && v !== '');
}


export const getTestTimezoneOffset = (test: { timezone?: number | null } | null | undefined): number => {
  return test?.timezone != null ? test.timezone : moment().utcOffset();
}


export const calculateTestDuration = (startTime: string | Date, endTime?: string | Date) => {
  if (!startTime) return 0;
  const start = typeof startTime === 'string' ? new Date(startTime) : startTime;
  const now = new Date();
  const end = endTime ? (typeof endTime === 'string' ? new Date(endTime) : endTime) : now;
  return Math.floor((end.getTime() - start.getTime()) / 1000);
}

export async function sha256Hex(input: string): Promise<string> {
  const bytes = new TextEncoder().encode(input);
  const hash = await crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(hash))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}